export enum SINGLE_PAGE_SECTIONS {
  about = "about",
  benefits = "benefits",
  details = "details",
  ratings = "ratings",
}
